import * as React from 'react';
import { __ } from '../../../helpers/TranslationService';
import { IShip } from '../../../interfaces';

interface ICruiseShipTitle {
    title: string;
    ship: IShip;
}

const CruiseShipTitle = ({ title, ship }: ICruiseShipTitle) => {
    return (
        <div>
            <div className="cruise-header-mobile_title">
                <h1 className="cruise-header-mobile_title_h1">
                    {title}
                </h1>
            </div>
        </div>
    );
};
export default CruiseShipTitle;
